module.exports = __webpack_public_path__ + "static/media/sale.c9d44f57.svg";